<template>
    <div :class="['video-time-item', {'not-logged': disabled}]">
        <div class="video-time-item__section" v-if="isLabel"> {{ title }}</div>
        <div
            v-else role="button"
            class="video-time-item__content"
            @click="assignSectionInfo"
            :class="{ 'video-time-item__no-checkbox': !isVideo }"
        >
            <span class="video-time-item__icon" v-bind:class="getSectionIcon"></span>
            <div class="video-time-item__timecode-container">
                <span class="video-time-item__title"> {{ title | truncate(85) }} </span>
                <span v-if="this.sectionType === 'video'" class="video-time-item__time">({{ convertTimeToMinutesAndHours(time) }}) </span>
            </div>
            <span v-if="isVideo" class="video-time-item__icon-completion" v-bind:class="isSectionCompleted"></span>
        </div>
    </div>
</template>

<script>
    import truncate from 'components/shared/mixins/truncate'
    import microLearningHelper from 'components/shared/mixins/microLearningHelper'

    export default {
        name: 'MicroLearningOverViewItem',
        props: {
            time: Number,
            title: String,
            disabled: {
                type: Boolean,
                default: false
            },
            sectionType: String,
            microLearningElementId: Number,
            allCurrentlyWatchedSequences: {
                type: Array,
                default: () => []
            },
            isCompleted: {
                type: Boolean,
                default: false
            },
            section: Object
        },
        mixins: [ truncate, microLearningHelper ],
        data () {
            return {
                videoTimeRange: [
                    0,
                    this.time || 99999999999999
                ]
            }
        },
        computed: {
            isLabel () {
                return this.time === ''
            },
            isSectionCompleted () {
                if (!this.isCompleted) {
                    return 'icon-square-o'
                } else {
                    return 'icon-check-square'
                }
            },
            // eslint-disable-next-line vue/return-in-computed-property
            getSectionIcon () {
                switch (this.sectionType) {
                case 'video':
                    return 'icon-film1'
                case 'assignment':
                    return 'icon-pencil-square'
                case 'file':
                    return 'icon-file-text-o'
                }
            },
            isVideo () {
                return this.sectionType === 'video'
            }
        },
        methods: {
            async assignSectionInfo () {
                this.$router.replace({ name: this.getCorrectRouteForMicroLearning, query: { element: this.section.elementId } })
                if (this.sectionType === 'video') {
                    await this.$store.dispatch('Courses/changeCourseVideo', this.section)
                    this.$emit('reInitializeVideo')
                }
                await this.$store.dispatch('MicroLearning/assignMicroLearningSection', this.section)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .video-time-item {
        display: flex;
        flex-direction: column;
        font-size: 1.5rem;
        position: relative;
        color: $black;

        &.not-logged {
            color: $white;

            .video-time-item {
                &__section {
                    color: $black;
                }

                &__content {
                    &:hover {
                        @include white(background, 0.1);
                    }
                }

                &__time {
                    color: $black;
                }
            }
        }

        &__section {
            font-family: Quicksand-Bold, sans-serif;
            color: $black;
            padding: 15px 15px;
        }

        &__content {
            display: flex;
            padding: 8px 30px;
            background: $white;
            position: relative;
            flex-direction: row;
            align-items: center;

            &:hover {
                cursor: pointer;
                background: $wild_sand;
            }
            &.in-progress {
                @include white(background, 0.1);
            }
        }

        &__no-checkbox {
            padding: 8px 72px;
        }

        &__time {
            color: $black;
            margin: 0 10px 0 0;
            width: 100%;
            font-size: 1.3rem;
        }

        &__title {
            font-size: 1.4rem;
            width: 100%;
            font-family: Nunito-Regular, sans-serif;
        }

        &__icon {
            margin: 0px 7px 0 0;
            font-size: 1.8rem;
            color: $orange;
        }

        &__icon-completion {
            font-size: 1.8rem;
            color: $heavy_metal;
            margin-left: auto;
        }

        .icon-checked {
            color: $ice_cold;
            position: absolute;
            right: 20px;
            top: 20px;
            font-size: 2rem;
        }
        .progress-circle {
            position: absolute;
            right: 15px;
            top: 15px;
        }

        .icon-square-o:before, .icon-square:before {
            cursor: auto;
        }
    }
</style>
